import React, {
    useEffect,
    useState,
    useRef,
    Fragment,
    useMemo,
} from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Tabs, Tab, Button, Autocomplete, CircularProgress, TextField, FormHelperText, OutlinedInput, IconButton, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { getData, postData } from '../../services/fetch-service';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import ReCAPTCHA from 'react-google-recaptcha';
import { LoadingOverlay, Loader, Badge, Text, Skeleton } from '@mantine/core';
import { setAlertMessage, setEsimCountriesList, setEsimPackages, setEsimPackageSelected, setEsimPackageSelectedBox, setEsimRefillSelected, setEsimRefillSelectedBox, setPaymentResponse, setPaymentSuccess } from '../store/dataslice';
import Swal from 'sweetalert2';
import { FaEuroSign, FaWifi } from 'react-icons/fa';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { IoMdClose } from 'react-icons/io';
import { CiWifiOn } from "react-icons/ci";
import { animateScroll } from 'react-scroll';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const E_sim_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);

    const EsimPackages = useSelector((state) => state.Website.data.EsimPackages);
    const EsimPackageSelected = useSelector((state) => state.Website.data.EsimPackageSelected);
    const EsimPackageSelectedBox = useSelector((state) => state.Website.data.EsimPackageSelectedBox);
    const EsimCountriesList = useSelector((state) => state.Website.data.EsimCountriesList);
    const EsimRefillSelectedBox = useSelector((state) => state.Website.data.EsimRefillSelectedBox);
    const EsimRefillSelected = useSelector((state) => state.Website.data.EsimRefillSelected);

    // console.log('EsimPackages', EsimPackages)
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [Loan, setLoan] = useState(false);
    const [shumaValue, setShumaValue] = useState(null);
    const [tabValue, setTabValue] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null);
    const [DataNumriSerik, setNumriSerik] = useState(null);
    const [acceptPay, setAccpetPay] = useState(false);

    useEffect(() => {
        if (tabValue === 0 && EsimPackageSelected && EsimPackageSelected.id) {
            setNumriSerik(EsimPackageSelected.id)
        } else if (tabValue === 1 && EsimRefillSelected && EsimRefillSelected.id) {
            setNumriSerik(EsimRefillSelected.id)
        }
        setPaymentMethodCode("wallet");
    }, [tabValue, EsimRefillSelected, EsimPackageSelected]);

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    const handleBack = () => {
        navigate('/');
        formik.resetForm();
        dispatch(setEsimPackageSelected(null));
        dispatch(setEsimRefillSelected(null));
        setSelectedRow(null);
    }

    const handleBackToESIM = () => {
        dispatch(setEsimPackageSelected(null));
        formik.resetForm();
        setSelectedRow(null);
        setPaymentMethodCode("wallet");
    }

    const handleBackToESIMrefill = () => {
        formik.resetForm();
        dispatch(setEsimRefillSelected(null));
        setSelectedRow(null);
        setPaymentMethodCode("wallet");
    }

    const getPackages = async () => {
        try {
            const response = await getData('VIAeSIM/GetPackages');
            if (response && response.data && response.data.packages) {
                const sortedPackages = response.data.packages.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
                dispatch(setEsimPackages(sortedPackages));
            }
            if (response && response.data && response.data.countries) {
                const mappedCountries = response.data.countries.map((country, index) => ({
                    id: index + 1,
                    label: country
                }));

                dispatch(setEsimCountriesList(mappedCountries));
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: 'Ka ndodhur një gabim!'
            });
        }
    };

    useEffect(() => {
        getPackages();
        dispatch(setEsimPackageSelected(null));
    }, []);

    //  *** add vlera per institucionin dhe llojin e pageses *** END

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        emri: Yup.string().required('Emri është obligative!'),
        mbiemri: Yup.string().required('Mbiemri është obligativ!'),
        paguesiNumriTelefonit: Yup.string().required('Numri Telefonit është obligative!'),
    });

    const refill_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        emri: Yup.string().required('Emri është obligative!'),
        mbiemri: Yup.string().required('Mbiemri është obligativ!'),
        paguesiNumriTelefonit: Yup.string().required('Numri Telefonit është obligative!'),
        numriIdentifikues: Yup.string().required('ESIM ID është obligative!'),
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const formik = useFormik({
        initialValues: {
            Email: '',
            provizioni: 0,
            strProvizioni: '0',
            llojiPagesesID: '',
            numriIdentifikues: selectedRow && selectedRow.esim_id ? selectedRow.esim_id : '',
            institucioniId: '',
            numriSerik: `${DataNumriSerik}`,
            strDataPageses: `${strDataPageses}`,
            llojiKlientit: 'Fizik',
            emri: '',
            mbiemri: '',
            pershkrimi: 'Pagesa online',
            strVlera: '',
            strVleraTotale: '0',
            paymentMethod: 3,
            paguesiNumriTelefonit: '',
            sherbimiTipiID: 7,
            // shpenzimet: 0,
            unirefOK: false,
            PaymentMethodCode: paymentMethodCode
        },
        validationSchema: tabValue === 0 ? payment_validationSchema : refill_validationSchema,
        onSubmit: (values) => {
            const newValues = {
                ...values,
                numriSerik: `${DataNumriSerik}`,
                pershkrimi: tabValue === 0 ? `${EsimPackageSelected && EsimPackageSelected.country_name} ${EsimPackageSelected && EsimPackageSelected.name}`
                    : `${EsimRefillSelected && EsimRefillSelected.country_name} ${EsimRefillSelected && EsimRefillSelected.name}`
            }
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(newValues);
        },
    });

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                mbiemri: data.mbiemri !== '' ? data.mbiemri : '//',
                shuma: shumaValue,
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                numriIdentifikues: data.numriIdentifikues !== '' ? `${data.numriIdentifikues}` : '',
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                llojiPagesesID: tabValue === 0 ? 1162 : 1163,
                institucioniId: 186,
                numriSerik: data.numriSerik,
                // numriSerik:
                //     (EsimPackageSelected && `${EsimPackageSelected.id}`) ||
                //     (EsimRefillSelected && `${EsimRefillSelected.id}`),
                numriUnikPageses: null,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode,
            }
            if (provizioni) {
                const response = await postData('Pagesat/PagesaPerSherbime', newData);
                if (response && response.status === 200) {
                    // if (!Loan && paymentMethodCode !== 'visa') {
                    //     dispatch(setPaymentResponse(response.data.respond));
                    //     setPagesaLoading(false);
                    // } else {
                    //     setLoanLoading(false);
                    //     const paymentWindow = window.open('', '_self');
                    //     paymentWindow.location.href = `${response.data.link}`;
                    // }
                    setLoanLoading(false);
                    setPagesaLoading(false);
                    setUpdateLoader(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setPagesaLoading(false);
            setLoanLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = async () => {
        formik.validateForm().then(async (errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                // await getProvizioni();
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    };

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }
    // provisioni
    const [finalPay, setFinalPay] = useState(true);
    const [provizioni, setProvizioni] = useState(null);
    const [shumaKey, setShumaKey] = useState(0);

    const getProvizioni = async (data) => {
        try {
            setAccpetPay(true);
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=${tabValue === 0 ? 1162 : 1163}&Amount=${shumaValue}`, data);
            if (response && response.data && response.data.success === true) {
                setProvizioni(response.data);
                setAccpetPay(false);
                setFinalPay(false);
            } else if (response && response.data && response.data.success === false) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Informim',
                    text: `${response.data.responseText}`
                });
                formik.setFieldValue('shuma', null);
                setShumaValue(null);
                setProvizioni(null);
                setShumaKey(prev => prev + 1);
            }
        } catch (error) {
            // Swal.fire({
            //     icon: 'error',
            //     title: 'Gabim',
            //     text: 'Ka ndodhur një gabim!'
            // });
            formik.setFieldValue('shuma', null);
            setShumaValue(null);
            setProvizioni(null);
            setShumaKey(prev => prev + 1);
            // setInstitucioniList(null);
        }
    }

    // const handleShumaChange = (event) => {
    //     setShumaValue(event.target.value);
    //     formik.setFieldValue('shuma', event.target.value)
    // };

    useEffect(() => {
        if (EsimPackageSelected !== null && EsimPackageSelected.price) {
            setShumaValue(EsimPackageSelected.price);

        }
        animateScroll.scrollToTop({
            duration: 500,
            smooth: true,
        });
    }, [EsimPackageSelected]);

    useEffect(() => {
        if (EsimRefillSelected !== null && EsimRefillSelected.price) {
            setShumaValue(EsimRefillSelected.price);
        }
        animateScroll.scrollToTop({
            duration: 500,
            smooth: true,
        });
    }, [EsimRefillSelected]);

    useEffect(() => {
        if (shumaValue !== null) {
            getProvizioni();
        }
    }, [shumaValue]);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        formik.resetForm();
        setFinalPay(true);
        dispatch(setEsimPackageSelected(null));
        dispatch(setEsimRefillSelected(null));
        dispatch(setEsimRefillSelectedBox(null));
        setSelectedRow(null);
    };

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [filteredPackages, setFilteredPackages] = useState([]);

    useEffect(() => {
        if (selectedCountry && EsimPackages?.length > 0) {
            const filtered = EsimPackages.filter(pkg =>
                pkg.destination?.countries?.some(
                    country => country?.emri === selectedCountry.label
                )
            );
            setFilteredPackages(filtered);
        } else {
            setFilteredPackages([EsimPackages]);
        }
    }, [selectedCountry, EsimPackages]);


    const handleEsimBoxClick = (data) => {
        dispatch(setEsimRefillSelectedBox(data));
    };

    const handleEsimClick = (data) => {
        dispatch(setEsimRefillSelected(data));
    };

    const handleEsimBuyBoxClick = (data) => {
        dispatch(setEsimPackageSelectedBox(data));
    };

    // kerkimi permes email
    const [emailInput, setEmailInput] = useState();
    const [searchEmailOpen, setSearchEmailOpen] = useState(false);
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [kerkoEmailLoading, setKerkoEmailLoading] = useState(false);

    const [emailsList, setEmailsList] = useState(null);

    const handleEmailSearch = () => {
        setKerkoEmailLoading(true);
        fetchEmailServiceData();
    };

    const fetchEmailServiceData = async () => {
        try {
            const response = await getData(`VIAeSIM/GetIccIdListByEmail?email=${emailInput}`);
            if (response) {
                const data = response.data.iccids;

                if (!data || data.length === 0) {
                    setEmailsList(null);
                    setKerkoEmailLoading(false);
                    Swal.fire({
                        icon: 'info',
                        title: 'Nuk u gjetën të dhëna',
                        text: 'Nuk keni eSIM të regjistruar me këtë email.'
                    });
                    return;
                }

                setEmailsList(data);
                setKerkoEmailLoading(false);
            }
        } catch (error) {
            setKerkoEmailLoading(false);
            setEmailsList(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Ka ndodhur një gabim!"
            });
        }
    };


    async function handleSearch() {
        // event.preventDefault();
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            // fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handleClickOpen = () => {
        setSearchEmailOpen(true);
    };
    const handleClose = () => {
        setSearchEmailOpen(false);
    };

    const [refillCountriesListOpen, setRefillCountriesListOpen] = useState(false);

    const handleRefillCountriesOpen = () => {
        setRefillCountriesListOpen(true);
    };
    const handleRefillCountriesClose = () => {
        setRefillCountriesListOpen(false);
    };

    const [refillCountriesListOpenHome, setRefillCountriesListOpenHome] = useState(false);

    const handleRefillCountriesOpenHome = () => {
        setRefillCountriesListOpenHome(true);
    };

    const handleRefillCountriesCloseHome = () => {
        setRefillCountriesListOpenHome(false);
    };

    const [buyCountriesListOpenHome, setBuyCountriesListOpenHome] = useState(false);

    const handleBuyCountriesOpenHome = () => {
        setBuyCountriesListOpenHome(true);
    };

    const handleBuyCountriesCloseHome = () => {
        setBuyCountriesListOpenHome(false);
    };

    const [buyCountriesListOpen, setBuyCountriesListOpen] = useState(false);

    const handleBuyCountriesOpen = () => {
        setBuyCountriesListOpen(true);
    };

    const handleBuyCountriesClose = () => {
        setBuyCountriesListOpen(false);
    };

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setSearchEmailOpen(false);
        formik.setFieldValue('Email', emailInput)
        formik.setFieldValue('numriIdentifikues', row.esim_id)
        // setNumriSerik(row.uniref)
    };

    useEffect(() => {
        if (selectedRow !== null) {
            handleSearch();
        }

    }, [selectedRow]);

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
                <span className='home-description body-font'>Thjesht klikoni në njërën nga pakot, pajisu me internet 4G/5G në krejt Europën.</span>
            </div>
            <div className="paysera-form-body other-feilds">
                <div className="form-box">
                    <Divider className='subheading-font esim-divider' textAlign="center">
                        <Tabs className='esim-tabs' value={tabValue} onChange={handleChange} centered>
                            <Tab label="Blej" />
                            <Tab label="Rimbush" />
                        </Tabs>
                    </Divider>
                    <div className="form-body">
                        {tabValue === 0 && EsimPackages ? (
                            <Fragment>
                                {
                                    EsimPackages.length === 0 ? (
                                        <div className="esim-grid esimRefill-grid">
                                            {Array.from({ length: 12 }).map((_, index) => (
                                                <Skeleton key={index} height={200} className="skeleton-box" />
                                            ))}
                                        </div>
                                    )
                                        : (

                                            <div className="paysera-esim-form">
                                                {EsimPackageSelected === null ?
                                                    <div className="esim-grid">
                                                        {EsimPackageSelectedBox && EsimPackageSelectedBox.id &&
                                                            <Fragment>
                                                                <BootstrapDialog
                                                                    className='CountriesList-Modal'
                                                                    onClose={handleBuyCountriesCloseHome}
                                                                    aria-labelledby="customized-dialog-title"
                                                                    open={buyCountriesListOpenHome}
                                                                >
                                                                    <DialogTitle className="dialog-title" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                                                        Lista e Shteteve për {EsimPackageSelectedBox.country_name}
                                                                    </DialogTitle>
                                                                    <IconButton
                                                                        aria-label="close"
                                                                        onClick={handleBuyCountriesCloseHome}
                                                                        sx={{
                                                                            position: 'absolute',
                                                                            right: 8,
                                                                            top: 8,
                                                                            color: (theme) => theme.palette.grey[500],
                                                                        }}
                                                                    >
                                                                        <IoMdClose />
                                                                    </IconButton>
                                                                    <DialogContent dividers>
                                                                        <ul className="esim-countries-list">
                                                                            {EsimPackageSelectedBox.destination.countries.map((country, index) => (
                                                                                <li key={index}>
                                                                                    <img src={country.flag_url} alt={`${country.country_name} flag`} className="flag-icon" />
                                                                                    <h3>{`${country.name}`}</h3>
                                                                                </li>
                                                                            ))}
                                                                        </ul>

                                                                    </DialogContent>
                                                                    <DialogActions>
                                                                        <Button autoFocus onClick={handleBuyCountriesCloseHome}>
                                                                            Kthehu
                                                                        </Button>
                                                                    </DialogActions>
                                                                </BootstrapDialog>
                                                            </Fragment>
                                                        }
                                                        {EsimPackages.map((data, index) => (
                                                            <div key={index} className="esim-card">
                                                                <div className="card-details-desc">
                                                                    <div className="card-header">
                                                                        <img src={data.flag_url} alt={`${data.country_name} flag`} className="flag-icon" />
                                                                        <h3>{`${data.country_name} ${data.name}`}</h3>
                                                                    </div>
                                                                    <div className="card-price card-price-home">
                                                                        <strong>{parseFloat(data.price).toFixed(2)}€</strong> <Text className='esim-days' c="dimmed">{data.days} ditë vlefshmëri</Text>
                                                                    </div>
                                                                    <div className="card-details">
                                                                        <Text className='details-cm allowance-cm' c="dimmed">
                                                                            <FaWifi /> {data.data_allowance_gb?.includes('PA LIMIT') ? 'PA LIMIT' : `${data.data_allowance_gb}GB`}
                                                                        </Text>

                                                                        <Button
                                                                            variant="text"
                                                                            className="esim-btn flags-btn"
                                                                            onClick={() => {
                                                                                handleEsimBuyBoxClick(data);
                                                                                handleBuyCountriesOpenHome();
                                                                            }}
                                                                        >
                                                                            <Text className='details-cm flags-cm' c="dimmed">
                                                                                {data.destination.countries.length} Shtete të mbuluara
                                                                            </Text>
                                                                            <div className="flag-stack">
                                                                                {data.destination.countries.slice(0, 3).map((country, index) => (
                                                                                    <img
                                                                                        key={index}
                                                                                        src={country.flag_url}
                                                                                        alt={country.name}
                                                                                        className="flag-icon-stacked"
                                                                                        style={{ zIndex: 10 - index }}
                                                                                    />
                                                                                ))}
                                                                            </div>
                                                                        </Button>

                                                                    </div>
                                                                </div>
                                                                <Button
                                                                    className="esim-btn"
                                                                    onClick={() => dispatch(setEsimPackageSelected(data))}
                                                                >
                                                                    Blej tani
                                                                </Button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    : (
                                                        <div className="paysera-form esim-details-form">
                                                            {EsimPackageSelected && EsimPackageSelected.id &&
                                                                <Fragment>
                                                                    <BootstrapDialog
                                                                        className='CountriesList-Modal'
                                                                        onClose={handleBuyCountriesClose}
                                                                        aria-labelledby="customized-dialog-title"
                                                                        open={buyCountriesListOpen}
                                                                    >
                                                                        <DialogTitle className="dialog-title" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                                                            Lista e Shteteve për {EsimPackageSelected.country_name}
                                                                        </DialogTitle>
                                                                        <IconButton
                                                                            aria-label="close"
                                                                            onClick={handleBuyCountriesClose}
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                right: 8,
                                                                                top: 8,
                                                                                color: (theme) => theme.palette.grey[500],
                                                                            }}
                                                                        >
                                                                            <IoMdClose />
                                                                        </IconButton>
                                                                        <DialogContent dividers>
                                                                            <ul className="esim-countries-list">
                                                                                {EsimPackageSelected.destination.countries.map((country, index) => (
                                                                                    <li key={index}>
                                                                                        <img src={country.flag_url} alt={`${country.country_name} flag`} className="flag-icon" />
                                                                                        <h3>{`${country.name}`}</h3>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>

                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button autoFocus onClick={handleBuyCountriesClose}>
                                                                                Kthehu
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </BootstrapDialog>

                                                                    <div className="esim-detail-box">
                                                                        <div className="card-header">
                                                                            <img src={EsimPackageSelected.flag_url} alt={`${EsimPackageSelected.country_name} flag`} className="flag-icon" />
                                                                            <h3>{`${EsimPackageSelected.country_name} ${EsimPackageSelected.name}`}</h3>
                                                                        </div>
                                                                        <div className="card-price">
                                                                            <strong>{parseFloat(EsimPackageSelected.price).toFixed(2)}€</strong><span className='esim-days'> - {EsimPackageSelected.days} ditë vlefshmëri</span>
                                                                        </div>

                                                                        <div className="card-details">
                                                                            <Text className='details-cm' c="dimmed"><FaWifi /> {EsimPackageSelected.data_allowance_gb?.includes('PA LIMIT') ? 'PA LIMIT' : `${EsimPackageSelected.data_allowance_gb}GB`}</Text>
                                                                            <Button variant="text" className="esim-btn flags-btn" onClick={handleBuyCountriesOpen}>
                                                                                <Text className='details-cm flags-cm' c="dimmed">
                                                                                    {EsimPackageSelected.destination.countries.length} Shtete të mbuluara
                                                                                </Text>
                                                                                <div className="flag-stack">
                                                                                    {EsimPackageSelected.destination.countries.slice(0, 3).map((country, index) => (
                                                                                        <img
                                                                                            key={index}
                                                                                            src={country.flag_url}
                                                                                            alt={country.name}
                                                                                            className="flag-icon-stacked"
                                                                                            style={{ zIndex: 10 - index }}
                                                                                        />
                                                                                    ))}
                                                                                </div>
                                                                            </Button>
                                                                        </div>

                                                                    </div>
                                                                </Fragment>
                                                            }
                                                            <div className="paysera-inputLabel">
                                                                <label
                                                                    className={formik.touched.emri && formik.errors.emri ? 'label-top' : ''}
                                                                    htmlFor='Emri'
                                                                >
                                                                    Emri
                                                                    <span className="required"> *</span>
                                                                </label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="outlined-adornment-input"
                                                                        placeholder='Emri'
                                                                        type='text'
                                                                        name='emri'
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                        }}
                                                                        value={formik.values.emri}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        error={formik.touched.emri && formik.errors.emri}
                                                                    />
                                                                    {
                                                                        formik.touched.emri && formik.errors.emri && (
                                                                            <FormHelperText>{formik.errors.emri}</FormHelperText>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="paysera-inputLabel">
                                                                <label
                                                                    htmlFor="mbiemri"
                                                                    className={formik.touched.mbiemri && formik.errors.mbiemri ? 'label-top' : ''}
                                                                >
                                                                    Mbiemri
                                                                    <span className="required"> *</span>
                                                                </label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="outlined-adornment-input"
                                                                        placeholder="Mbiemri"
                                                                        type='text'
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                        }}
                                                                        name='mbiemri'
                                                                        value={formik.values.mbiemri}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        error={formik.touched.mbiemri && formik.errors.mbiemri}
                                                                    />
                                                                    {
                                                                        formik.touched.mbiemri && formik.errors.mbiemri && (
                                                                            <FormHelperText>{formik.errors.mbiemri}</FormHelperText>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="paysera-inputLabel">
                                                                <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="outlined-adornment-input"
                                                                        placeholder="Shëno email-in tuaj"
                                                                        name='Email'
                                                                        type="email"
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                        }}
                                                                        value={formik.values.Email}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        error={formik.touched.Email && formik.errors.Email}
                                                                    />
                                                                    {
                                                                        formik.touched.Email && formik.errors.Email && (
                                                                            <FormHelperText>{formik.errors.Email}</FormHelperText>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="paysera-inputLabel">
                                                                <label className={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit ? 'label-top' : ''} htmlFor="Numri Serik">Numri Telefonit <span className="required">*</span></label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="outlined-adornment-input"
                                                                        placeholder="Shëno numrin e telefonit"
                                                                        name='paguesiNumriTelefonit'
                                                                        type=""
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                        }}
                                                                        value={formik.values.paguesiNumriTelefonit}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        error={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit}
                                                                    />
                                                                    {
                                                                        formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit && (
                                                                            <FormHelperText>{formik.errors.paguesiNumriTelefonit}</FormHelperText>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="paysera-inputLabel">
                                                                <label
                                                                    className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''}
                                                                    htmlFor="Shuma e pagesës"
                                                                >
                                                                    Shuma e pagesës <span className="required">*</span>
                                                                </label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="shuma-input-nr"
                                                                        type='number'
                                                                        disabled
                                                                        name='shuma'
                                                                        key={shumaKey}
                                                                        placeholder="Shuma për pagesë"
                                                                        className='number-input'
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                            // inputMode: 'numeric'
                                                                        }}
                                                                        value={shumaValue}
                                                                        endAdornment={<FaEuroSign />}
                                                                        error={formik.touched.shuma && formik.errors.shuma}
                                                                    />
                                                                    {
                                                                        formik.touched.shuma && formik.errors.shuma && (
                                                                            <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="paysera-inputLabel">
                                                                <label htmlFor="Provizioni"> Provizioni</label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="outlined-adornment-input"
                                                                        placeholder="Provizioni"
                                                                        key={shumaKey}
                                                                        readOnly
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                        }}
                                                                        name='Provizioni'
                                                                        value={provizioni && provizioni.provizioni}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="paysera-inputLabel">
                                                                <label htmlFor="Provizioni">Shuma Totale</label>
                                                                <div className="input">
                                                                    <OutlinedInput
                                                                        size="small"
                                                                        id="outlined-adornment-input"
                                                                        placeholder="Provizioni"
                                                                        endAdornment={<FaEuroSign />}
                                                                        key={shumaKey}
                                                                        readOnly
                                                                        aria-describedby="outlined-input-helper-text"
                                                                        startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                                        inputProps={{
                                                                            'aria-label': 'input',
                                                                        }}
                                                                        name='strVleraTotale'
                                                                        value={provizioni && provizioni.strtotal_pagesa}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                                            <div className="p-buttons">
                                                                <div className="payForm-btn">
                                                                    <Button type="button" variant="outlined" onClick={handleBackToESIM}>
                                                                        Kthehu në E-SIM
                                                                    </Button>
                                                                    {/* <Button
                                                                        id="payNow"
                                                                        type="button"
                                                                        variant="contained"
                                                                        onClick={handlePayWithLoan}
                                                                        // disabled
                                                                        disabled={loanLoading}
                                                                        startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                                                    >
                                                                        {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                                                    </Button> */}
                                                                    <Button
                                                                        id="payNow"
                                                                        type="button"
                                                                        variant="contained"
                                                                        onClick={handlePayProcess}
                                                                        disabled={finalPay || (pagesaLoading || acceptPay)}
                                                                        startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                                                    >
                                                                        {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                <div className="p-buttons">
                                                    <div className="payForm-btn">
                                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                                            Kthehu
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                            </Fragment>
                        ) : (tabValue === 1) ? (
                            <div className='paysera-esim-form paysera-esim-refill-form'>
                                {/* <Autocomplete
                                    // disablePortal
                                    // disabled
                                    id="combo-box-demo"
                                    options={EsimCountriesList}
                                    value={selectedCountry}
                                    onChange={(event, newValue) => setSelectedCountry(newValue)}
                                    sx={{ width: 300 }}
                                    size='small'
                                    name='institucioniId'
                                    loading={EsimCountriesList && EsimCountriesList.length === 0 ? true : false}
                                    loadingText={
                                        <div className="dropdownLoader">
                                            <CircularProgress size={20} color="inherit" />
                                        </div>
                                    }
                                    noOptionsText={
                                        EsimCountriesList && EsimCountriesList.length === 0 &&
                                        (
                                            <div className="dropdownLoader">
                                                <CircularProgress size={20} color="inherit" />
                                            </div>
                                        )
                                    }
                                    renderInput={(params) => (
                                        <div className="input">
                                            <TextField
                                                {...params}
                                                label=""
                                                variant="outlined"
                                                placeholder='Zgjedh institucionin'
                                                fullWidth
                                                error={formik.touched.institucioniId && formik.errors.institucioniId}
                                            />
                                            {
                                                formik.touched.institucioniId && formik.errors.institucioniId && (
                                                    <FormHelperText>{formik.errors.institucioniId}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    )}
                                /> */}
                                {/* Refill section */}

                                <Fragment>
                                    {
                                        EsimPackages.length === 0 ? (
                                            <div className="esim-grid esimRefill-grid">
                                                {Array.from({ length: 12 }).map((_, index) => (
                                                    <Skeleton key={index} height={200} className="skeleton-box" />
                                                ))}
                                            </div>
                                        )
                                            : (

                                                <Fragment>
                                                    {EsimRefillSelected === null ?
                                                        <Fragment>
                                                            <div className="esim-grid esimRefill-grid">

                                                                {EsimRefillSelectedBox && EsimRefillSelectedBox.id &&
                                                                    <Fragment>
                                                                        <BootstrapDialog
                                                                            className='CountriesList-Modal'
                                                                            onClose={handleRefillCountriesCloseHome}
                                                                            aria-labelledby="customized-dialog-title"
                                                                            open={refillCountriesListOpenHome}
                                                                        >
                                                                            <DialogTitle className="dialog-title" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                                                                Lista e Shteteve për {EsimRefillSelectedBox.country_name}
                                                                            </DialogTitle>
                                                                            <IconButton
                                                                                aria-label="close"
                                                                                onClick={handleRefillCountriesCloseHome}
                                                                                sx={{
                                                                                    position: 'absolute',
                                                                                    right: 8,
                                                                                    top: 8,
                                                                                    color: (theme) => theme.palette.grey[500],
                                                                                }}
                                                                            >
                                                                                <IoMdClose />
                                                                            </IconButton>
                                                                            <DialogContent dividers>
                                                                                <ul className="esim-countries-list">
                                                                                    {EsimRefillSelectedBox.destination.countries.map((country, index) => (
                                                                                        <li key={index}>
                                                                                            <img src={country.flag_url} alt={`${country.country_name} flag`} className="flag-icon" />
                                                                                            <h3>{`${country.name}`}</h3>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>

                                                                            </DialogContent>
                                                                            <DialogActions>
                                                                                <Button autoFocus onClick={handleRefillCountriesCloseHome}>
                                                                                    Kthehu
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </BootstrapDialog>
                                                                    </Fragment>
                                                                }

                                                                {EsimPackages.map((data, index) => (
                                                                    <div
                                                                        key={index}
                                                                        // className={`esim-card esim-refill-card ${data.id === EsimRefillSelectedBox?.id ? 'selected-refill' : ''}`}
                                                                        className="esim-card"
                                                                    >
                                                                        <div className="card-details-desc">
                                                                            <div className="card-header">
                                                                                <img src={data.flag_url} alt={`${data.country_name} flag`} className="flag-icon" />
                                                                                <h3>{`${data.country_name} ${data.name}`}</h3>
                                                                            </div>
                                                                            <div className="card-price card-price-home">
                                                                                <strong>{parseFloat(data.price).toFixed(2)}€</strong> <Text className='esim-days' c="dimmed">{data.days} ditë vlefshmëri</Text>
                                                                            </div>
                                                                            <div className="card-details">
                                                                                <Text className='details-cm allowance-cm' c="dimmed">
                                                                                    <FaWifi /> {data.data_allowance_gb?.includes('PA LIMIT') ? 'PA LIMIT' : `${data.data_allowance_gb}GB`}
                                                                                </Text>

                                                                                <Button
                                                                                    variant="text"
                                                                                    className="esim-btn flags-btn"
                                                                                    onClick={() => {
                                                                                        handleEsimBoxClick(data);
                                                                                        handleRefillCountriesOpenHome();
                                                                                    }}
                                                                                >
                                                                                    <Text className='details-cm flags-cm' c="dimmed">
                                                                                        {data.destination.countries.length} Shtete të mbuluara
                                                                                    </Text>
                                                                                    <div className="flag-stack">
                                                                                        {data.destination.countries.slice(0, 3).map((country, index) => (
                                                                                            <img
                                                                                                key={index}
                                                                                                src={country.flag_url}
                                                                                                alt={country.name}
                                                                                                className="flag-icon-stacked"
                                                                                                style={{ zIndex: 10 - index }}
                                                                                            />
                                                                                        ))}
                                                                                    </div>
                                                                                </Button>

                                                                            </div>
                                                                        </div>
                                                                        <Button
                                                                            className="esim-btn"
                                                                            onClick={() => handleEsimClick(data)}
                                                                        >
                                                                            Zgjidhni
                                                                        </Button>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                            {EsimRefillSelectedBox && EsimRefillSelectedBox.destination && EsimRefillSelectedBox.destination.countries.length > 0 &&
                                                                <Fragment>
                                                                    <Divider className="subheading-font" textAlign="center">Pako e Selektuar mbulon këto shtete</Divider>

                                                                    <div className="refillCountries-grid">
                                                                        {EsimRefillSelectedBox.destination.countries.map((data, index) => (
                                                                            <Badge key={index} color="#000066">{data.emri}</Badge>
                                                                        ))}
                                                                    </div>
                                                                </Fragment>
                                                            }
                                                        </Fragment>
                                                        : (
                                                            <Fragment>
                                                                <div className="paysera-form esim-details-form selected-esim-detail-from">
                                                                    {EsimRefillSelected && EsimRefillSelected.id &&
                                                                        <Fragment>
                                                                            <BootstrapDialog
                                                                                className='CountriesList-Modal'
                                                                                onClose={handleRefillCountriesClose}
                                                                                aria-labelledby="customized-dialog-title"
                                                                                open={refillCountriesListOpen}
                                                                            >
                                                                                <DialogTitle className="dialog-title" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                                                                    Lista e Shteteve për {EsimRefillSelected.country_name}
                                                                                </DialogTitle>
                                                                                <IconButton
                                                                                    aria-label="close"
                                                                                    onClick={handleRefillCountriesClose}
                                                                                    sx={{
                                                                                        position: 'absolute',
                                                                                        right: 8,
                                                                                        top: 8,
                                                                                        color: (theme) => theme.palette.grey[500],
                                                                                    }}
                                                                                >
                                                                                    <IoMdClose />
                                                                                </IconButton>
                                                                                <DialogContent dividers>
                                                                                    <ul className="esim-countries-list">
                                                                                        {EsimRefillSelected.destination.countries.map((country, index) => (
                                                                                            <li key={index}>
                                                                                                <img src={country.flag_url} alt={`${country.country_name} flag`} className="flag-icon" />
                                                                                                <h3>{`${country.name}`}</h3>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>

                                                                                </DialogContent>
                                                                                <DialogActions>
                                                                                    <Button autoFocus onClick={handleRefillCountriesClose}>
                                                                                        Kthehu
                                                                                    </Button>
                                                                                </DialogActions>
                                                                            </BootstrapDialog>

                                                                            <div className="esim-detail-box">
                                                                                <div className="card-header">
                                                                                    <img src={EsimRefillSelected.flag_url} alt={`${EsimRefillSelected.country_name} flag`} className="flag-icon" />
                                                                                    <h3>{`${EsimRefillSelected.country_name} ${EsimRefillSelected.name}`}</h3>
                                                                                </div>
                                                                                <div className="card-price">
                                                                                    <strong>{parseFloat(EsimRefillSelected.price).toFixed(2)}€</strong><span className='esim-days'> - {EsimRefillSelected.days} ditë vlefshmëri</span>
                                                                                </div>

                                                                                <div className="card-details">
                                                                                    <Text className='details-cm' c="dimmed"><FaWifi /> {EsimRefillSelected.data_allowance_gb?.includes('PA LIMIT') ? 'PA LIMIT' : `${EsimRefillSelected.data_allowance_gb}GB`}</Text>
                                                                                    <Button variant="text" className="esim-btn flags-btn" onClick={handleRefillCountriesOpen}>
                                                                                        <Text className='details-cm flags-cm' c="dimmed">
                                                                                            {EsimRefillSelected.destination.countries.length} Shtete të mbuluara
                                                                                        </Text>
                                                                                        <div className="flag-stack">
                                                                                            {EsimRefillSelected.destination.countries.slice(0, 3).map((country, index) => (
                                                                                                <img
                                                                                                    key={index}
                                                                                                    src={country.flag_url}
                                                                                                    alt={country.name}
                                                                                                    className="flag-icon-stacked"
                                                                                                    style={{ zIndex: 10 - index }}
                                                                                                />
                                                                                            ))}
                                                                                        </div>
                                                                                    </Button>
                                                                                </div>

                                                                            </div>
                                                                        </Fragment>
                                                                    }

                                                                </div>
                                                                <Divider className="subheading-font" textAlign="center">Detajet e pagesës</Divider>

                                                                <div className="paysera-form esim-details-form refill-esim-detail-from">
                                                                    <div className="refill-email-search">
                                                                        <Button variant="outlined btn-link" onClick={handleClickOpen}>
                                                                            Kërkoni ESIM ID-në përmes Email
                                                                        </Button>
                                                                    </div>
                                                                    <BootstrapDialog
                                                                        onClose={handleClose}
                                                                        aria-labelledby="customized-dialog-title"
                                                                        open={searchEmailOpen}
                                                                    >
                                                                        <DialogTitle className="dialog-title" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                                                            Kërkoni ESIM ID-në përmes Email
                                                                        </DialogTitle>
                                                                        <IconButton
                                                                            aria-label="close"
                                                                            onClick={handleClose}
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                right: 8,
                                                                                top: 8,
                                                                                color: (theme) => theme.palette.grey[500],
                                                                            }}
                                                                        >
                                                                            <IoMdClose />
                                                                        </IconButton>
                                                                        <DialogContent dividers>
                                                                            <div className="dialog-search">
                                                                                <div className="paysera-inputLabel s-Label">
                                                                                    <label htmlFor="emailInput"> Kërkoni me Email <span className="required">*</span></label>
                                                                                    <div className="s-input">
                                                                                        <OutlinedInput
                                                                                            size="small"
                                                                                            id="outlined-adornment-input"
                                                                                            placeholder="Email"
                                                                                            value={emailInput}
                                                                                            type="email"
                                                                                            aria-describedby="outlined-input-helper-text"
                                                                                            inputProps={{
                                                                                                'aria-label': 'input',
                                                                                            }}
                                                                                            onChange={(event) => setEmailInput(event.target.value)}
                                                                                            onKeyPress={(event) => {
                                                                                                if (event.key === 'Enter' && emailInput !== undefined) {
                                                                                                    handleEmailSearch();
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        <Button
                                                                                            type="button"
                                                                                            className="dynamic-button"
                                                                                            variant="contained"
                                                                                            onClick={handleEmailSearch}
                                                                                            disabled={kerkoEmailLoading || emailInput === undefined || emailInput === ''}
                                                                                        // startIcon={kerkoLoading && <CircularProgress size={20} color="inherit" />}
                                                                                        >
                                                                                            {kerkoEmailLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {emailsList && emailsList.length > 0 &&
                                                                                <div className="table-dt">
                                                                                    <Table stickyHeader className="fiskal-table" style={{ maxWidth: '100%', overflow: 'auto' }}>
                                                                                        <TableHead>
                                                                                            <TableRow>
                                                                                                <TableCell>Esim ID</TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>
                                                                                        <TableBody>
                                                                                            {emailsList.map((row) => (
                                                                                                <TableRow
                                                                                                    key={row.esim_id}
                                                                                                    selected={selectedRow && selectedRow.esim_id === row.esim_id}
                                                                                                    onClick={() => handleRowClick(row)}
                                                                                                >
                                                                                                    <TableCell>{row.esim_id || '/'}</TableCell>
                                                                                                </TableRow>
                                                                                            ))}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </div>

                                                                            }
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button autoFocus onClick={handleClose}>
                                                                                Kthehu
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </BootstrapDialog>
                                                                    <div className="paysera-inputLabel">
                                                                        <label
                                                                            className={formik.touched.numriIdentifikues && formik.errors.numriIdentifikues ? 'label-top' : ''}
                                                                            htmlFor='numriIdentifikues'
                                                                        >
                                                                            ESIM ID
                                                                            <span className="required"> *</span>
                                                                        </label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder='ESIM ID'
                                                                                type='text'
                                                                                name='numriIdentifikues'
                                                                                disabled
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                value={selectedRow?.esim_id}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                error={formik.touched.numriIdentifikues && formik.errors.numriIdentifikues}
                                                                            />
                                                                            {
                                                                                formik.touched.numriIdentifikues && formik.errors.numriIdentifikues && (
                                                                                    <FormHelperText>{formik.errors.numriIdentifikues}</FormHelperText>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="paysera-inputLabel">
                                                                        <label
                                                                            className={formik.touched.emri && formik.errors.emri ? 'label-top' : ''}
                                                                            htmlFor='Emri'
                                                                        >
                                                                            Emri
                                                                            <span className="required"> *</span>
                                                                        </label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder='Emri'
                                                                                type='text'
                                                                                name='emri'
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                value={formik.values.emri}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                error={formik.touched.emri && formik.errors.emri}
                                                                            />
                                                                            {
                                                                                formik.touched.emri && formik.errors.emri && (
                                                                                    <FormHelperText>{formik.errors.emri}</FormHelperText>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="paysera-inputLabel">
                                                                        <label
                                                                            htmlFor="mbiemri"
                                                                            className={formik.touched.mbiemri && formik.errors.mbiemri ? 'label-top' : ''}
                                                                        >
                                                                            Mbiemri
                                                                            <span className="required"> *</span>
                                                                        </label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder="Mbiemri"
                                                                                type='text'
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                name='mbiemri'
                                                                                value={formik.values.mbiemri}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                error={formik.touched.mbiemri && formik.errors.mbiemri}
                                                                            />
                                                                            {
                                                                                formik.touched.mbiemri && formik.errors.mbiemri && (
                                                                                    <FormHelperText>{formik.errors.mbiemri}</FormHelperText>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    <div className="paysera-inputLabel">
                                                                        <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder="Shëno email-in tuaj"
                                                                                name='Email'
                                                                                type="email"
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                value={formik.values.Email}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                error={formik.touched.Email && formik.errors.Email}
                                                                            />
                                                                            {
                                                                                formik.touched.Email && formik.errors.Email && (
                                                                                    <FormHelperText>{formik.errors.Email}</FormHelperText>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    <div className="paysera-inputLabel">
                                                                        <label className={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit ? 'label-top' : ''} htmlFor="Numri Serik">Numri Telefonit <span className="required">*</span></label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder="Shëno numrin e telefonit"
                                                                                name='paguesiNumriTelefonit'
                                                                                type=""
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                value={formik.values.paguesiNumriTelefonit}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                error={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit}
                                                                            />
                                                                            {
                                                                                formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit && (
                                                                                    <FormHelperText>{formik.errors.paguesiNumriTelefonit}</FormHelperText>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    <div className="paysera-inputLabel">
                                                                        <label
                                                                            className={formik.touched.strVlera && formik.errors.strVlera ? 'label-top' : ''}
                                                                            htmlFor="Shuma e pagesës"
                                                                        >
                                                                            Shuma e pagesës <span className="required">*</span>
                                                                        </label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="shuma-input-nr"
                                                                                type='number'
                                                                                disabled
                                                                                name='shuma'
                                                                                placeholder="Shuma për pagesë"
                                                                                className='number-input'
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                    // inputMode: 'numeric'
                                                                                }}
                                                                                value={shumaValue}
                                                                                endAdornment={<FaEuroSign />}
                                                                                error={formik.touched.shuma && formik.errors.shuma}
                                                                            />
                                                                            {
                                                                                formik.touched.shuma && formik.errors.shuma && (
                                                                                    <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="paysera-inputLabel">
                                                                        <label htmlFor="Provizioni"> Provizioni</label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder="Provizioni"

                                                                                readOnly
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                name='Provizioni'
                                                                                value={provizioni && provizioni.provizioni}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="paysera-inputLabel">
                                                                        <label htmlFor="Provizioni">Shuma Totale</label>
                                                                        <div className="input">
                                                                            <OutlinedInput
                                                                                size="small"
                                                                                id="outlined-adornment-input"
                                                                                placeholder="Provizioni"
                                                                                endAdornment={<FaEuroSign />}
                                                                                readOnly
                                                                                aria-describedby="outlined-input-helper-text"
                                                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                                                inputProps={{
                                                                                    'aria-label': 'input',
                                                                                }}
                                                                                name='strVleraTotale'
                                                                                value={provizioni && provizioni.strtotal_pagesa}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                                                    <div className="p-buttons">
                                                                        <div className="payForm-btn">
                                                                            <Button type="button" variant="outlined" onClick={handleBackToESIMrefill}>
                                                                                Kthehu në E-SIM
                                                                            </Button>
                                                                            {/* <Button
                                                                                id="payNow"
                                                                                type="button"
                                                                                variant="contained"
                                                                                onClick={handlePayWithLoan}
                                                                                // disabled
                                                                                disabled={loanLoading}
                                                                                startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                                                            >
                                                                                {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                                                            </Button> */}
                                                                            <Button
                                                                                id="payNow"
                                                                                type="button"
                                                                                variant="contained"
                                                                                onClick={handlePayProcess}
                                                                                disabled={finalPay || (pagesaLoading || acceptPay)}
                                                                                startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                                                            >
                                                                                {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                        )}
                                                </Fragment>
                                            )}
                                </Fragment>



                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes UNIREF.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div >
    )
}

export default E_sim_PaymentFields
